// imports
import { Chain } from 'wagmi/chains';

// interfaces / types / consts
const L1_URL = process.env.REACT_APP_L1_RPC_ENDPOINT as string || '';
const L2_URL = process.env.REACT_APP_L2_RPC_ENDPOINT as string || '';

// exports
export const L1Chain: Chain = {
  name: (process.env.REACT_APP_ENVIRONMENT === 'prod' || process.env.REACT_APP_ENVIRONMENT === 'stage') ? 'Ethereum Mainnet' : 'Sepolia',
  network: '',
  id: Number(process.env.REACT_APP_L1_CHAIN_ID || 0),
  nativeCurrency: { decimals: 0, name: '', symbol: '' },
  rpcUrls: {
    public: { http: [L1_URL] },
    default: { http: [L1_URL] }
  }
};
export const L2Chain: Chain = {
  name: (process.env.REACT_APP_ENVIRONMENT === 'prod' || process.env.REACT_APP_ENVIRONMENT === 'stage') ? 'Arbitrum Nova' : 'Arbitrum Georli',
  network: '',
  id: Number(process.env.REACT_APP_L2_CHAIN_ID || 0),
  nativeCurrency: { decimals: 0, name: '', symbol: '' },
  rpcUrls: {
    public: { http: [L2_URL] },
    default: { http: [L2_URL] }
  }
};
export default { L1Chain, L2Chain };
